import { Validator } from 'fluentvalidation-ts';
import { IItemDto } from '@app/shared/models/dtos/item';

export class ItemDtoValidator extends Validator<IItemDto> {
  constructor() {
    super();

    this.ruleFor('Name')
      .notEmpty()
      .withMessage('Name is required');

    this.ruleFor('Name').maxLength(200).withMessage('Name can not be more than 1000 characters.');

    this.ruleFor('FunctionId').greaterThan(0).withMessage('Function is required');
    this.ruleFor('ItemCategoryId').greaterThan(0).withMessage('Item Category is required');
    this.ruleFor('CostCodeCostTypeId').greaterThan(0).withMessage('GFCM code is required');
    this.ruleFor('PrimaryUOM').greaterThan(0).withMessage('Primary UOM is required');

  }
}